// @flow

import stores from 'stores';

export default () => {
  return stores.usersStore.resetUser();
};
